export const BANNER_ID = "BannerId";
export const BANNER_THANK_YOU_ID = "BannerThankYouId";
export const BANNER_TITLE_ID = "BannerTitleId";
export const BANNER_BODY_1_ID = "BannerBody1Id";
export const BANNER_BODY_2_ID = "BannerBody2Id";
export const BANNER_BODY_3_ID = "BannerBody3Id";
